import { PrimeNGModule } from './primeng.module'
import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PhoneFormatPipe } from '../pipes/phone.pipe'
import { DateFormatPipe } from '../pipes/date.pipe'
import { CastPipe } from '../pipes/cast.pipe'
import { NumericOnlyDirective, AlphaNumericOnlyDirective } from '../directives/numbers-only.directive'
import { DateDirective } from '../directives/date-field.directive'
import { MaskInputDirective } from '../directives/mask-input-directive'

@NgModule({
  declarations:
    [
      PhoneFormatPipe,
      DateFormatPipe,
      CastPipe,
      NumericOnlyDirective,
      MaskInputDirective,
      DateDirective,
      AlphaNumericOnlyDirective,
      MaskInputDirective
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNGModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNGModule,
    PhoneFormatPipe,
    DateFormatPipe,
    CastPipe,
    NumericOnlyDirective,
    DateDirective,
    AlphaNumericOnlyDirective,
    MaskInputDirective
  ],
  providers: [
    DatePipe
  ],
})
export class AppBaseModule { }
